import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-undo",
  templateUrl: "./med-icon-undo.component.html",
})
export class MedIconUndoComponent extends SvgMixinComponent {}
